import axiosAdmin from "../../api/axiosAdmin";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const DjDetailsPage = () => {
  const { id } = useParams();
  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [stripeAccountId, setStripeAccountId] = useState("");

  const fetchDjDetails = async () => {
    try {
      const response = await axiosAdmin.get(`/dj/${id}`);

      setRequest(response.data);
      setStripeAccountId(response.data.stripeAccountId || "");
    } catch (err) {
      setError("Failed to load dj details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDjDetails();
  }, [id]);

  const handleMakeOffline = async () => {
    if (!window.confirm("Are you sure you want to make offline this Dj?"))
      return;

    try {
      await axiosAdmin.patch(`/dj/${id}/offline`);

      toast.success("Dj is offline");
      fetchDjDetails();
    } catch (error) {
      console.error("Error while making offline", error);
      toast.error("Error while making offline");
    }
  };

  const handleUpdateStripeId = async () => {
    if (!stripeAccountId.trim()) {
      toast.error("Stripe Account ID cannot be empty");
      return;
    }

    try {
      await axiosAdmin.patch(`/dj/${id}/stripe-account`, { stripeAccountId });

      toast.success("Stripe Account ID updated");
      setShowModal(false);
      fetchDjDetails();
    } catch (error) {
      console.error("Error updating Stripe Account ID", error);
      toast.error("Error updating Stripe Account ID");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">DJ Details</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        {[
          { label: "ID", value: request.id },
          { label: "DJ", value: request.name },
          { label: "Username", value: request.username },
          { label: "Email", value: request.email },
          {
            label: "Status",
            value: (
              <>
                {request.online ? "Online" : "Offline"}{" "}
                <span
                  className={`inline-block w-3 h-3 rounded-full ${
                    request.online ? "bg-green-500" : "bg-red-500"
                  }`}
                ></span>
              </>
            ),
          },
          {
            label: "Price (PLN)",
            value: request.currentPrice || "N/A",
          },
          {
            label: "Place",
            value: request.place ? request.place.name : "N/A",
          },
          {
            label: "Stripe",
            value: (
              <div className="flex items-center justify-between flex-wrap">
                <span>{request.stripeAccountId || "N/A"}</span>
                <button
                  className="mt-2 md:mt-0 px-3 py-1 bg-blue-500 text-white rounded text-sm"
                  onClick={() => setShowModal(true)}
                >
                  Edit
                </button>
              </div>
            ),
          },
        ].map((item, index) => (
          <div
            key={item.label}
            className={`p-3 ${
              index % 2 === 0 ? "bg-gray-50" : "bg-white"
            } border-b`}
          >
            <strong>{item.label}:</strong>{" "}
            {typeof item.value === "string" ? (
              <span className="ml-1">{item.value}</span>
            ) : (
              item.value
            )}
          </div>
        ))}

        {request.online && (
          <div className="p-4">
            <button
              onClick={handleMakeOffline}
              className="w-full px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded"
            >
              Set DJ as Offline
            </button>
          </div>
        )}
      </div>

      {/* Stripe Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">Update Stripe Account ID</h2>
            <input
              type="text"
              value={stripeAccountId}
              onChange={(e) => setStripeAccountId(e.target.value)}
              placeholder="Enter new Stripe Account ID"
              className="w-full p-2 border rounded mb-4"
            />
            <div className="flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateStripeId}
                className="px-4 py-2 bg-blue-500 text-white rounded"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DjDetailsPage;
